import { useQuery } from '@api/hooks';
import { MarketBasketStatus } from '@domain'
import { Autocomplete, TextField } from '@mui/material';
import MarketBasketsApi, { MarketBasketsKeys } from '@services/marketBaskets.api';
import { useMarketBasketContext } from '@views/MarketBaskets/MarketBaskets.hooks';
import { useParams } from 'react-router-dom';
import { UrlUpdateType } from 'use-query-params';


type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function PackSize({ value, updateFilters }: Props) {
	const { marketBasketId } = useParams()
	const { marketBasket } = useMarketBasketContext()

	const isRecalculating = marketBasket?.status === MarketBasketStatus.RECALCULATING

	const { data, isLoading } = useQuery({
		queryKey: MarketBasketsKeys.packSizes(marketBasketId),
		queryFn: () => MarketBasketsApi.packSizes(marketBasketId),
		enabled: !isRecalculating,
	})

	const selectedPackSize = data?.find((v) => v === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ packSize: value })
		} else {
			updateFilters({ packSize: null })
		}
	}

	return (
		<Autocomplete
			disabled={isLoading || isRecalculating}
			fullWidth
			size="small"
			options={data || []}
			value={selectedPackSize}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Pack Size" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
